import { render, staticRenderFns } from "./CommonHistoryList.vue?vue&type=template&id=ec541ab4&scoped=true&"
import script from "./CommonHistoryList.vue?vue&type=script&lang=js&"
export * from "./CommonHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./CommonHistoryList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./CommonHistoryList.vue?vue&type=style&index=1&id=ec541ab4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec541ab4",
  null
  
)

export default component.exports